export const clfValueFields = [{
        name: "code",
        title: "Codice"
    }, {
        name: "displayOrder",
        title: "Ordine di visualizzazione"
    }, {
        name: "description",
        title: "Descrizione"
    }];
